import { Component, input, signal } from '@angular/core';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';
import { FormGroup } from '@angular/forms';
import { ALL_EXTERNAL_ASSIGNABLE_ROLES, ALL_ROLES, TextUtils } from '@mira-avant/mtlibs';
import { AuthService } from '../../../../services/auth.service';

@Component({
	selector: 'app-role-dropdown-field',
	imports: [DropdownControl],
	templateUrl: './role-dropdown-field.html',
	styleUrl: './role-dropdown-field.scss',
})
export class RoleDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	constructor(private authService: AuthService) {
		this.authService.isAdmin$().then(isAdmin => {
			if (isAdmin) {
				this.options.set(
					ALL_ROLES.map(role => ({
						value: role,
						label: TextUtils.convertSnakeCaseToTitleCase(role),
					}))
				);
			} else {
				this.options.set(
					ALL_EXTERNAL_ASSIGNABLE_ROLES.map(role => ({
						value: role,
						label: TextUtils.convertSnakeCaseToTitleCase(role),
					}))
				);
			}
		});
	}
}
